import { render, staticRenderFns } from "./ot-claim-documents-index.vue?vue&type=template&id=725b5943&scoped=true&"
import script from "./ot-claim-documents-index.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-documents-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-documents-index.vue?vue&type=style&index=0&id=725b5943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b5943",
  null
  
)

export default component.exports